


export const setTitle = ( title ) => {

    return { type:'SET_TITLE', payload:title };

};

export const clearTitle = () => {

    return { type:'CLEAR_TITLE' };

};